<template>
  <div>
    <div class="spcore-box p-3">
      <div class="pb-3">
        <div class="hvh-flex space-between align-center width-100">
          <h2 class="hvh-h6">{{ title }}</h2>
          <h2 class="hvh-h6 p-2" style="background-color: rgba(140, 202, 200, 0.25)">21 Day Goal</h2>
        </div>
      </div>
      <div class="hvh-flex space-between align-center p-2" style="background-color: rgba(140, 202, 200, 0.25)">
        <div class="hvh-flex">
          <div class="mr-2"><v-icon small color="green">mdi-square</v-icon> On Track</div>
          <div class="mr-2"><v-icon small color="yellow">mdi-square</v-icon> Deleyad</div>
          <div><v-icon small color="orange">mdi-square</v-icon> At Risk</div>
        </div>
        <div style="background-color: #e51a2c; padding: 5px 10px; border-radius: 12px; color: white" v-if="data.data">{{ patientsNotMeetGoal }} ({{ Math.round(percentPatientsNotMeetGoal) }}%) did not meet goal</div>
      </div>
      <div class="v-card__text px-0">
        <div class="hvh-analysis-visualization__chart">
          <LineareachartFilter
            style="background-color: #f5fbfb"
            :nameField="nameField"
            :valueField="valueField"
            :filterObject="filterObject"
            :isChecked="isChecked"
            :data="data"
            :options="chartOptions"
            :isFiltering="isFiltering"
            height="200px"
            @checked-changed="emitChange"
            @chart-created="$emit('refresh-data', $event)"
            @refresh-data="$emit('refresh-data', $event)"
          />
          <div class="pr-4" style="text-align: end">
            <span class="clickable">{{ clickText }} ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import LineareachartFilter from '../charts/filters/LineareachartFilter.vue';
export default {
  noExport: true,
  components: { LineareachartFilter },
  props: ['title', 'data', 'filterObject', 'isFiltering', 'selected', 'valueField', 'nameField', 'clickText'],
  data() {
    return {
      chartOptions: {
        backgroundColor: '#f5fbfb',
        yAxis: {
          name: 'Patients',
          nameGap: 55,
          nameTextStyle: {
            fontWeight: 'bold',
            fontSize: 13
          },
        },
      }
    };
  },
  methods: {
    emitChange(event, data) {
      this.$emit('checked-changed', event, data);
    },
    isChecked(event) {
      return !(this.selected || []).length || (this.selected || []).includes(event.filterValue);
    },
  },
  computed: {
    patientsNotMeetGoal() {
      return this.data.originalData && this.data.originalData.filter(f => f.noOfDays >= 21).sum(f => f.patientCount);
    },
    percentPatientsNotMeetGoal() {
      return this.data.originalData && this.patientsNotMeetGoal / this.data.originalData.sum(f => f.patientCount) * 100;
    },
  },
}
</script>
